/**
 * 图鉴累计：localStorage 持久化
 * 用 scpId + features hash 作为去重 key
 */

const KEY = "codexMonsters";
const MAX_SIZE = 2000;

interface CodexEntry {
  scpId: string;
  class: string;
  features: string[];
  ts: number;
}

function readAll(): CodexEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.slice(0, MAX_SIZE);
  } catch {
    return [];
  }
}

function writeAll(entries: CodexEntry[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX_SIZE)));
  } catch {
    /* quota exceeded or disabled */
  }
}

function entryKey(e: { scpId: string; features: string[] }): string {
  return `${e.scpId}|${[...e.features].sort().join(",")}`;
}

export function getCodexCount(): number {
  return readAll().length;
}

export function addMonsters(monsters: { scpId: string; class: string; features: string[] }[]): number {
  const list = readAll();
  const existingKeys = new Set(list.map(entryKey));
  const now = Date.now();
  let added = 0;
  for (const m of monsters) {
    const k = entryKey(m);
    if (!existingKeys.has(k)) {
      list.unshift({ ...m, ts: now });
      existingKeys.add(k);
      added++;
    }
  }
  writeAll(list);
  return added;
}

export function clearCodex(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
